import { useEffect, useState } from 'react'

import { Tooltip as ReactTooltip } from 'react-tooltip'

import { Box } from 'app/components/design-system-components'
import { ErrorBox } from 'app/components/forms/util'
import { pmsPropertyMeID } from 'app/constants/pms.constants'
import { deactivatePMS, getPMSConfig } from 'app/services/http/pms'
import * as snugNotifier from 'app/services/snugNotifier'
import * as Form from 'app/shared_components/form_component'

export const PMSPropertyMeIntegration = ({
  agencyId,
  integrationsBundleEnabled,
}: any) => {
  const [isEnabled, setIsEnabled] = useState(false)
  const [isActive, setIsActive] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [apiErr, setApiErr] = useState(null)

  useEffect(() => {
    setApiErr(null)
    getPMSConfig(agencyId, pmsPropertyMeID)
      .then((config: any) => {
        const { enabled } = config || {}
        setIsActive(!!enabled)
        setIsEnabled(!!enabled)
      })
      .catch(({ message }: any) => {
        snugNotifier.error(message)
        setApiErr(message)
      })
  }, [agencyId])

  const deactivate = () => {
    if (!isActive) {
      snugNotifier.error('PropertyMe PMS not activated')
      return
    }

    setApiErr(null)
    setIsLoading(true)

    deactivatePMS(agencyId, pmsPropertyMeID)
      .then(() => {
        setIsActive(false)
        setIsEnabled(false)
      })
      .catch(({ message }: any) => {
        snugNotifier.error(message)
        setApiErr(message)
      })
      .finally(() => setIsLoading(false))
  }

  return (
    <Box mb={4} className={'col-sm-12'} pl={0}>
      <Form.Checkbox
        id="propertyMeAppEnabled"
        label={`Enable ${pmsPropertyMeID}`}
        checked={isEnabled}
        onChange={() => {}}
        readOnly={isActive || !integrationsBundleEnabled}
        toolTip={
          <div>
            <i
              className="icon-help-outline fs16 gray-light-color ibm"
              data-tooltip-content=""
              data-tooltip-id="propertyMeIntegration"
            />
          </div>
        }
      />

      <Box>
        <ReactTooltip id="propertyMeIntegration">
          <span>
            PropertyMe can only be activated in team settings. It can be
            deactivated here by customer service.
          </span>
        </ReactTooltip>
      </Box>

      {isEnabled && (
        <>
          <Box mb={4}>
            <ErrorBox error={apiErr} showError={!!apiErr} />
          </Box>

          <Form.Button
            className="mb10 mr10"
            onClick={deactivate}
            disabled={!isActive}
            label={isActive ? 'Deactivate' : 'N/A'}
            loading={isLoading}
          />
        </>
      )}
    </Box>
  )
}
